export function useGetLinks() {
  function getNotificationURL(notification: string) {
    const notificationURL =
      `https://dalngpw1.na.xom.com/sap/bc/ui5_ui5/ui2/` +
      `ushell/shells/abap/FioriLaunchpad.html#` +
      `EPM_Historian-notificationHistorian` +
      `&/ChangeNotification/${notification}`

    return notificationURL
  }

  function getWorkOrderURL({
    code,
    workOrder,
  }: {
    code: string
    workOrder: string
  }) {
    const systemId = code.split('.')[0].toLowerCase()
    const serverName = systemId?.toUpperCase().startsWith('G9P')
      ? 'hoeg9p'
      : `sap${systemId}`

    const workOrderURL =
      `https://${serverName}w1.na.xom.com/sap/bc/gui/sap/its/webgui/` +
      `?sap-client=100&sap-language=en&~transaction=*IW33 CAUFVD-AUFNR=` +
      `${workOrder};DYNP_OKCODE=/00`

    return workOrderURL
  }

  return { getNotificationURL, getWorkOrderURL }
}
